import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicAttachments({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M10.643.503c.428 0 .856.107 1.177.215 1.285.534 2.034 1.713 2.034 3.105 0 .855-.321 1.712-.964 2.355l-5.994 6.1c-.215.215-.428.322-.643.428-.214.107-.427.107-.749.107-.214 0-.536 0-.749-.107-.214-.106-.427-.214-.536-.427-.214-.215-.32-.428-.427-.643-.107-.215-.107-.534-.107-.749 0-.536.215-1.07.536-1.392l5.46-5.672c.106-.107.321-.215.428-.215.214 0 .427.106.536.215.106.106.214.32.214.427-.106.215-.106.322-.214.536l-5.568 5.565a.82.82 0 00-.215.536c0 .321.321.643.642.643.215 0 .322-.107.428-.215l5.994-6.1c.428-.429.535-.856.535-1.392 0-.536-.215-.964-.535-1.392a1.527 1.527 0 00-1.285-.643c-.536 0-1.07.215-1.391.643l-5.993 6.1a3.827 3.827 0 00-.749 1.071 3.265 3.265 0 000 2.462c.215.428.428.749.75 1.07.642.643 1.39.964 2.246.964.856 0 1.713-.321 2.248-.964l6.102-5.994c.107-.215.215-.215.428-.215.215 0 .321.107.428.215.106.107.214.215.214.428s-.106.321-.214.428l-5.995 6.102c-.427.428-.963.75-1.498 1.07a4.428 4.428 0 01-1.713.322 4.428 4.428 0 01-1.712-.322c-.536-.214-1.07-.536-1.499-1.07A4.51 4.51 0 011.33 12.6a4.877 4.877 0 01-.32-1.713c0-.642.107-1.177.321-1.82.215-.535.536-1.07.964-1.497L8.29 1.469a3.308 3.308 0 012.354-.966z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicAttachments.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicAttachments.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicAttachments svgRef={ref} {...props} />
));
export default ForwardRef;
